// import Swiper JS
import { Swiper, Pagination } from 'swiper';

export const spacesSlider = () => {
	let spacesSliderModules = document.querySelectorAll('.m__sslider');
	if(spacesSliderModules){
		
		spacesSliderModules.forEach((spacesSliderModule) => {

			let spacesSliderSlides = spacesSliderModule.querySelectorAll('.m__sslider__swiper-slide ');

			let slideVideos 		= spacesSliderModule.querySelectorAll('.js__sslider-video');
			//Trigger the first video on page load
			if(slideVideos.length > 0){
				for (var source in slideVideos[0].children) {
				  var videoSource = slideVideos[0].children[source];
				  if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
				    videoSource.src = videoSource.dataset.src;
				  }
				}
				slideVideos[0].load();
				slideVideos[0].play();
			}

			if(spacesSliderSlides.length > 1){
				//Initialise the slider
				const pSwiper = new Swiper(spacesSliderModule.querySelector('.m__sslider__swiper-wrapper .swiper'), {
					modules: [Pagination],
					centeredSlides : true,
					slidesPerView : 1,
					pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
					rewind : true,
					loop: false,
					keyboard: {
						enabled: true,
						onlyInViewport: true,
					},
				});

				let ssliderNavItems 	= spacesSliderModule.querySelectorAll('.js__sslider-nav-item');
			

				//Updates when a slide changes
				pSwiper.on('slideChange', function () {


					//Change selected 'nav' item when the slide changes
					ssliderNavItems.forEach((navItem) => {
						if(navItem.getAttribute("data-slide-index") == pSwiper.realIndex){
							navItem.classList.add('active');
						}else{
							navItem.classList.remove('active');
						}
					});


					//Stop all videos from playing
					slideVideos.forEach((slideVideo) => {
						slideVideo.pause();
						slideVideo.currentTime = 0;
						slideVideo.load();
					})

					//Check for any videos on the slide and make sure they're lazy-loaded (Had a bug with intersection observer not being triggered due to how swiper loads items)
					let slideVideo = pSwiper.slides[pSwiper.activeIndex].querySelector("video"); 
					if(slideVideo){
						if(!slideVideo.currentTime > 0){ //Only reload video if it isn't already playing
							for (var source in slideVideo.children) {
							  var videoSource = slideVideo.children[source];
							  if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
							    videoSource.src = videoSource.dataset.src;
							  }
							}
							slideVideo.load();	
							slideVideoTimeout = setTimeout(() => {
								slideVideo.play();
							},1000);
						}
							          
					}
				});

				//Update displated slide if 'nav' item clicked
				ssliderNavItems.forEach((navItem) => {
					navItem.addEventListener('click', (event) => {
						pSwiper.slideTo(navItem.getAttribute("data-slide-index"));
					})
				});
				
			}else{
				//Only 1 slide - don't power up swiper and just manually add the active class (doing a foreach here juuuust in case)
				spacesSliderSlides.forEach((slide) => {
					slide.classList.add('swiper-slide-active');
				})
				
			}
		});
	}
}